export default __webpack_public_path__ + "static/media/slider_image_03-xs@1x.5a055aa8.webp";